import { z } from 'zod';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { OrganizationUserRole } from 'libs/end-to-end/src/types/users/organization-user-roles';
import { DatabasesWithVisibleRevisions } from 'libs/end-to-end/src/types/databases/database-with-visible-revision';

export const MyOrganization = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  role: OrganizationUserRole,
  hasDataAvailable: z.boolean(),
  latestObservation: ObservationLocationType.nullable(),
  selectedObservationLocation: ObservationLocationType.nullable(),
  databasesWithVisibleRevisions: DatabasesWithVisibleRevisions,
});

export type MyOrganization = z.infer<typeof MyOrganization>;
